export default {
  arrayCategorias (state) {
    return state.categoriaSelecionadas
  }
}



// WEBPACK FOOTER //
// ./src/store/cadastro/getters.js